import React from 'react';
import 'antd/dist/reset.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import PrivateRoute from './components/PrivateRoute';
import PermisoRoute from './components/PermisoRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SinAcceso from './pages/SinAcceso';
import ProductoNuevo from './pages/ProductoNuevo';
import ProductoEditar from './pages/ProductoEditar';
import FrmProductoLista from './pages/FrmProductoLista';
import Frmcentrocosto from './pages/Frmcentrocosto';
import Frmentrada from './pages/Frmentrada';
import FrminventarioTable from './pages/FrmInventarioTable';
import FrmAnularIngreso from './pages/FrmAnularIngreso';
import FrmAjusteInventario from './pages/FrmAjusteInventario';
import FrmAnimalLista from './pages/FrmAnimalLista';
import FrmAnimalForm from './pages/FrmAnimalForm';
import FrmLecheHistorial from './pages/FrmLecheHistorial';
import FrmLecheBatch from './pages/FrmLecheBatch';
import FrmLecheEstadisticas from './pages/FrmLecheEstadisticas';
import FrmLecheVaca from './pages/FrmLecheVaca';
import FrmGestionProduccion from './pages/FrmGestionProduccion';
import FrmConfigLeche from './pages/FrmConfigLeche';
import FrmAnimalPesos from './pages/FrmAnimalPesos';
import FrmSalud from './pages/FrmSalud';
import FrmCultivoLista from './pages/FrmCultivoLista';
import FrmCultivoForm from './pages/FrmCultivoForm';
import FrmCultivoDetalle from './pages/FrmCultivoDetalle';
import FrmTipoCultivo from './pages/FrmTipoCultivo';
import FrmUsuarioLista from './pages/FrmUsuarioLista';
import FrmUsuarioForm from './pages/FrmUsuarioForm';
import FrmRoles from './pages/FrmRoles';

const P = ({ modulo, children }) => (
  <PermisoRoute modulo={modulo}>{children}</PermisoRoute>
);

const App = () => (
  <UserProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />

          {/* ── Inventario ── */}
          <Route path="productonuevo"       element={<P modulo="inventario"><ProductoNuevo /></P>} />
          <Route path="producto/lista"      element={<P modulo="inventario"><FrmProductoLista /></P>} />
          <Route path="producto/:id/editar" element={<P modulo="inventario"><ProductoEditar /></P>} />
          <Route path="Frmcentrocosto"      element={<P modulo="inventario"><Frmcentrocosto /></P>} />
          <Route path="Frmentrada"          element={<P modulo="inventario"><Frmentrada /></P>} />
          <Route path="FrminventarioTable"  element={<P modulo="inventario"><FrminventarioTable /></P>} />
          <Route path="FrmAnularIngreso"    element={<P modulo="inventario"><FrmAnularIngreso /></P>} />
          <Route path="FrmAjusteInventario" element={<P modulo="inventario"><FrmAjusteInventario /></P>} />

          {/* ── Ganado ── */}
          <Route path="ganado/animales"            element={<P modulo="ganado"><FrmAnimalLista /></P>} />
          <Route path="ganado/animales/nuevo"      element={<P modulo="ganado"><FrmAnimalForm /></P>} />
          <Route path="ganado/animales/:id/editar" element={<P modulo="ganado"><FrmAnimalForm /></P>} />
          <Route path="ganado/animales/:id/pesos"  element={<P modulo="ganado"><FrmAnimalPesos /></P>} />
          <Route path="ganado/animales/:id/salud"  element={<P modulo="ganado"><FrmSalud /></P>} />
          <Route path="ganado/animales/:id/leche"  element={<P modulo="leche"><FrmLecheHistorial /></P>} />
          <Route path="ganado/animales/:id"        element={<P modulo="ganado"><FrmAnimalForm /></P>} />

          {/* ── Leche ── */}
          <Route path="ganado/leche/lote"        element={<P modulo="leche"><FrmLecheBatch /></P>} />
          <Route path="ganado/leche/estadisticas" element={<P modulo="reportes"><FrmLecheEstadisticas /></P>} />
          <Route path="ganado/leche/vaca"        element={<P modulo="reportes"><FrmLecheVaca /></P>} />
          <Route path="ganado/leche/produccion"  element={<P modulo="leche"><FrmGestionProduccion /></P>} />
          <Route path="ganado/leche/config"      element={<P modulo="configuracion"><FrmConfigLeche /></P>} />

          {/* ── Cultivos ── */}
          <Route path="cultivos"           element={<P modulo="cultivos"><FrmCultivoLista /></P>} />
          <Route path="cultivos/tipos"     element={<P modulo="cultivos"><FrmTipoCultivo /></P>} />
          <Route path="cultivos/nuevo"     element={<P modulo="cultivos"><FrmCultivoForm /></P>} />
          <Route path="cultivos/:id/editar" element={<P modulo="cultivos"><FrmCultivoForm /></P>} />
          <Route path="cultivos/:id"       element={<P modulo="cultivos"><FrmCultivoDetalle /></P>} />

          {/* ── Usuarios y Roles ── */}
          <Route path="usuarios"           element={<P modulo="usuarios"><FrmUsuarioLista /></P>} />
          <Route path="usuarios/nuevo"     element={<P modulo="usuarios"><FrmUsuarioForm /></P>} />
          <Route path="usuarios/:id/editar" element={<P modulo="usuarios"><FrmUsuarioForm /></P>} />
          <Route path="roles"              element={<P modulo="usuarios"><FrmRoles /></P>} />

          {/* Sin acceso */}
          <Route path="sin-acceso" element={<SinAcceso />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  </UserProvider>
);

export default App;
